import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../state/store";
import { DataTable } from "../../components/DataTable/DataTable";
import { TournamentHeader } from "../../components/TournamentComponents/TournamentHeader";
import { DateInput, StringInput } from "../../components/Inputs";
import {
  getTournamentsTopPages,
  getTournamentsUsage,
  setTournamentsUsage,
} from "../../state/actions/tournamentActions";
import dayjs from "dayjs";
import { Row } from "../../components/Row";
import { Check } from "../../components/Check/Check";
import { useDocumentTitle } from "../../hooks/useDocumentTitle";

export function TournamentsUsage() {
  useDocumentTitle("Usage - BQA Tournaments");
  const dispatch = useAppDispatch();
  const { tournamentsUsage, selectedPage } = useAppSelector(
    (state) => state.tournaments
  );

  const [pageId, setPageId] = useState(selectedPage?.pageId || "");
  const [secondaryId, setSecondaryId] = useState(
    selectedPage?.secondaryId || ""
  );
  const [startDate, setStartDate] = useState(
    dayjs().subtract(30, "days").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(dayjs().format("YYYY-MM-DD"));

  const [dateRangeAllPages, setDateRangeAllPages] = useState(false);
  const [onePage, setOnePage] = useState(true);

  return (
    <div className="page">
      <TournamentHeader
        pageName="Tournaments Usage"
        navigateBack="/tournaments"
      />
      <DateInput
        caption="Start Date"
        value={startDate}
        onChange={setStartDate}
      />
      <DateInput caption="End Date" value={endDate} onChange={setEndDate} />
      <Check checked={dateRangeAllPages} onClick={setDateRangeAllPages}>
        Use Date Range for All Pages
      </Check>
      <StringInput caption="Page ID" value={pageId} onChange={setPageId} />
      <StringInput
        caption="Secondary ID"
        value={secondaryId}
        onChange={setSecondaryId}
      />
      <Row style={{ marginTop: 10 }}>
        <button
          className="clickable"
          onClick={() => {
            dispatch(setTournamentsUsage([]));
            dispatch(
              getTournamentsUsage(pageId, secondaryId, startDate, endDate)
            );
            setOnePage(true);
          }}
          style={{ width: 165, marginRight: 10 }}
        >
          Views - This Page
        </button>
        <button
          className="clickable"
          onClick={() => {
            dispatch(setTournamentsUsage([]));
            dispatch(
              dateRangeAllPages
                ? getTournamentsTopPages(startDate, endDate)
                : getTournamentsTopPages()
            );
            setOnePage(false);
          }}
          style={{ width: 165 }}
        >
          Views - All Pages
        </button>
      </Row>

      <DataTable
        data={tournamentsUsage}
        columns={[
          {
            title: "#",
            property: "number",
            render: (_, index) => String(index + 1),
          },
          {
            title: "Date",
            property: "date",
            render: (obj) => obj.date,
            visible: onePage,
          },
          {
            title: "Page",
            property: "page",
            render: (obj) => `${obj.pageId} ${obj.secondaryId || ""}`,
            visible: !onePage,
            maxWidth: 230,
          },
          {
            title: "Page View Count",
            property: "count",
            render: (obj) => obj.count,
          },
        ]}
        style={{ maxWidth: 600, marginTop: 20 }}
        getKey={(obj) =>
          onePage ? obj.date : `${obj.pageId} ${obj.secondaryId}`
        }
      />
    </div>
  );
}
